import React, { useState, useEffect } from "react";
import { MyCartContainer } from "./MyCartStyled";
import { useNavigate } from 'react-router-dom';

import { FormattedMessage, useIntl } from 'react-intl';

import arrowBack from './../../utils/images/arrow_back.svg';
import cash from './../../utils/images/cash.svg';

import { formatNumber, toUpperCase } from "../../services/generalSevices";
import ModalSendCollaboration from "../../components/ModalSendCollaboration/ModalSendCollaboration";
import { useContext } from "react";
import { UserContext } from "../../context/userContext";
import { LangContext } from "../../context/langContext";

import Spinner from "./../../components/Spinner/Spinner";
import { CartContext } from "../../context/cartContext";
import { deleteCollaboration, getCartCollaboration, postCollaboration, putCollaborationStatus } from "../../api/collaborationApi";
import ModalEditCollaboration from "../../components/ModalEditCollaboration/ModalEditCollaboration";
import { CurrencyContext } from "../../context/currencyContext";
import CollaborationCart from "./CollaborationCart";
import { getConvertCurrency } from "../../api/exchangeApi";
import { PayPalScriptProvider } from "@paypal/react-paypal-js";
import Checkout from "./Checkout";
import Alert from "../../components/Alert/Alert";
import { paypalURL } from "../../utils/constants/constants";
import { createOrder, preDiscount, validateCupon } from "../../api/paypalApi";


export default function MyCart() {

    const navigate = useNavigate();
    const intl = useIntl();
    const { locale } = useContext(LangContext);

    const { currency } = useContext(CurrencyContext);

    const [showCollaborationSent, setShowCollaborationSent] = useState(false);

    const [isLoading, setIsLoading] = useState(true);
    const { id, userToken, userType, companyName, country, city, address, phone, indicativePhone, payment } = useContext(UserContext);
    const { setShoppingCartCount, cart, setCart, cartTotal, setCartTotal, discountCode, setDiscountCode, cuponApply, setCuponApply } = useContext(CartContext);

    const [auxCartTotal, setAuxCartTotal] = useState(null);
    const [discount, setDiscount] = useState(0);
    const [auxDiscount, setAuxDiscount] = useState(null);
    const [taxes, setTaxes] = useState(0);
    const [auxTaxes, setAuxTaxes] = useState(null);
    const [influencerName, setInfluencerName] = useState('');

    const [editCollaborationData, setEditCollaborationData] = useState({});
    const [showEditCollaboration, setShowEditCollaboration] = useState(false);

    //const auxCurrency = currency.symbol

    const [showCollaborationCart, setShowCollaborationCart] = useState(false);
    const [showPaypalAlert, setShowPaypalAlert] = useState(false);

    const [showDiscountAlert, setShowDiscountAlert] = useState(false);

    const [hasGifts, setHasGifts] = useState(false);

    const initialOptions = {
        "client-id": /* process.env.PAYPAL_CLIENT_ID, */"ASNHf_FrV18rVQV0DtctGaGwmi0fQvBN1kcHpcFDFcZDgw6qh2gfwZFMObCbs5IFifiwzHgTy2umldDj",
        currency: "USD",
        intent: "authorize",
        //intent: "capture",
    };

    useEffect(() => {
        const gifts = cart.some(objeto => objeto.gift === true);
        setHasGifts(gifts);
    }, [cart])


    useEffect(() => {

        if (userToken !== null) {
            setCart([]);
            getCartCollaboration({ token: userToken }).then((response) => {
                setIsLoading(false)
                setShoppingCartCount(response.length)
                setCart(response);
                setShowCollaborationCart(true);
                setInfluencerName(response[0]?.influincr?.givenName)
                let suma = 0
                for (let i = 0; i < response.length; i++) {
                    suma += response[i].totalPrice
                }
                setCartTotal(suma);
            })
        }

    }, [userToken, showEditCollaboration])

    useEffect(() => {
        const auxCurrency = currency?.symbol;
        getConvertCurrency({ amount: cartTotal }).then((response) => {
            //setAuxCartTotal(response[auxCurrency].toFixed(0))
            setAuxCartTotal(response[auxCurrency]?.toFixed(2))
        })
        getConvertCurrency({ amount: discount }).then((response) => {
            //setAuxDiscount(response[auxCurrency].toFixed(0))
            setAuxDiscount(response[auxCurrency]?.toFixed(2))
        })
        getConvertCurrency({ amount: taxes }).then((response) => {
            //setAuxTaxes(response[auxCurrency].toFixed(0))
            setAuxTaxes(response[auxCurrency]?.toFixed(2))
        })

    }, [currency, cartTotal, discount, taxes])


    useEffect(() => {
        if (cuponApply) {
            validateCupon({ cuponBody: { name: discountCode }, token: userToken }).then((response) => {
                if (response.status === 200) {
                    let couponsAvailable = response.message.total_cupons - response.message.used_cupons;
                    let auxDiscount = 0;
                    let maxNumberDiscount = 0;

                    if (couponsAvailable < cart.length) {
                        maxNumberDiscount = couponsAvailable;
                    } else {
                        maxNumberDiscount = cart.length;
                    }
                    /* const cuponBody = []
                    cart.map((colab) => {
                        cuponBody.push({ id: colab.id, cuponCode: discountCode })
                    })

                    console.log(cuponBody)
                    preDiscount({ cuponBody: { colaborations: cuponBody }, token: userToken }).then((response) => {
                        console.log(response)
                        let auxDiscount = 0;
                        response.items.map((item) => {
                            auxDiscount = auxDiscount + item.discount
                        })
                        console.log(auxDiscount)
                    }) */
                    for (let index = 0; index < maxNumberDiscount; index++) {
                        const element = cart[index];
                        if (element.totalPrice !== 0) {
                            if (((element.totalPrice + element?.giftValue) * (response.message.percentaje / 100)) < response.message.max_value) {
                                if (element.gift) {
                                    auxDiscount = auxDiscount + ((element.totalPrice + element?.giftValue) * (response.message.percentaje / 100))
                                } else {
                                    auxDiscount = auxDiscount + ((element.totalPrice) * (response.message.percentaje / 100))
                                }

                            } else {
                                auxDiscount = auxDiscount + response.message.max_value;
                            }
                        }
                    }
                    setDiscount(auxDiscount);
                } else {
                    setShowDiscountAlert(true);
                    setCuponApply(false);
                    setDiscountCode('');
                    setDiscount(0);
                }
            })
        }
    }, [cuponApply, cartTotal])


    const payCollaboration = () => {

        /* if (payment) {
           setIsLoading(true)
           if (cuponApply) {
               validateCupon({ cuponBody: { name: discountCode }, token: userToken }).then((response) => {
                   console.log(response)
                   if (response.status === 200) {
                       let remainingCoupons = response.message.total_cupons - response.message.used_cupons;
                       const auxOrders = [];
                       cart.map(async (collaboration) => {
                           if (remainingCoupons > 0) {
                               auxOrders.push({ id: collaboration.id, cuponCode: discountCode })
                           } else {
                               auxOrders.push({ id: collaboration.id })
                           }
                       })
                       console.log("🫥", auxOrders)
                       createOrder({
                           orderBody: { colaborations: auxOrders }, token: userToken
                       }).then((response) => {
                           console.log(response)
                       })

                        const auxCart = cart.map(async (collaboration) => {

                            
                           console.log("🙂", remainingCoupons)
                           const orderBody = {
                               id: collaboration.id
                           }
                           if (remainingCoupons > 0) {
                               orderBody.cuponCode = discountCode
                           }

                           console.log("🧪", orderBody)
                           remainingCoupons = remainingCoupons - 1;
                           return await createOrder({
                               orderBody: orderBody, token: userToken
                           }).then((response) => {
                               console.log(response)
                           }) 
                       })
                       Promise.all(auxCart).then(response => {
                           const auxCart = cart.map(async (collaboration) => {
                               return await putCollaborationStatus({ collaborationId: collaboration.id, newStatus: 1, token: userToken }).then((response) => {
                                   console.log(response)
                               })
                           })

                           Promise.all(auxCart).then(response => {
                               setCart([]);
                               setShowCollaborationSent(true)
                               setShoppingCartCount(0)
                               setIsLoading(false)

                           })
                       }) 
                   }
                   else {
                       window.alert('Cupon no existe, está vencido, o ya no hay disponible')
                   }
               })
           } else {
               window.alert('Sin cupón');
               const auxOrders = [];
               cart.map(async (collaboration) => {

                   auxOrders.push({ id: collaboration.id })

               })
               console.log("🫥", auxOrders)
               createOrder({
                   orderBody: { colaborations: auxOrders }, token: userToken
               }).then((response) => {
                   console.log(response)
               })
                const auxCart = cart.map(async (collaboration) => {
                   const orderBody = {
                       id: collaboration.id
                   }
                   return await createOrder({
                       orderBody: orderBody, token: userToken
                   }).then((response) => {
                       console.log(response)
                   })
               })
               Promise.all(auxCart).then(response => {
                   const auxCart = cart.map(async (collaboration) => {
                       return await putCollaborationStatus({ collaborationId: collaboration.id, newStatus: 1, token: userToken }).then((response) => {
                           console.log(response)
                       })
                   })

                   Promise.all(auxCart).then(response => {
                       setCart([]);
                       setShowCollaborationSent(true)
                       setShoppingCartCount(0)
                       setIsLoading(false)

                   })
               }) 
           }

       } else {
           setShowPaypalAlert(true);
       }  */


        /* if (payment) {
            const auxCart = cart.map(async (collaboration) => {
                return await putCollaborationStatus({ collaborationId: collaboration.id, newStatus: 1, token: userToken }).then((response) => {
                    console.log(response)
                })
            })

            Promise.all(auxCart).then(response => {
                setCart([]);
                setShowCollaborationSent(true)
                setShoppingCartCount(0)

            })
        } else {
            setShowPaypalAlert(true);
        } */
        //setShowPaypalAlert(true);
        const auxCart = cart.map(async (collaboration) => {
            return await putCollaborationStatus({ collaborationId: collaboration.id, newStatus: 1, token: userToken }).then((response) => {
                console.log(response)
            })
        })

        Promise.all(auxCart).then(response => {
            setCart([]);
            setShowCollaborationSent(true)
            setShoppingCartCount(0)

        })
    }


    const handlerDeleteCollaboration = (collaborationId) => {

        setIsLoading(true)
        const newCart = cart.filter((collaboration) => collaboration.id !== collaborationId)

        deleteCollaboration({ collaborationId: collaborationId, token: userToken }).then((response) => {

            setIsLoading(false)

            if (response.status === 200) {
                setCart(newCart)
                setShoppingCartCount(newCart.length)
                let suma = 0

                for (let i = 0; i < newCart.length; i++) {
                    suma += newCart[i].totalPrice
                }

                setCartTotal(suma);
            }
        })

    }

    const applyDiscount = () => {

        setCuponApply(true);
        if (cartTotal > 0) {
            validateCupon({ cuponBody: { name: discountCode }, token: userToken }).then((response) => {
                if (response.status === 200) {
                    let couponsAvailable = response.message.total_cupons - response.message.used_cupons;
                    let auxDiscount = 0;
                    let maxNumberDiscount = 0;

                    if (couponsAvailable < cart.length) {
                        maxNumberDiscount = couponsAvailable;
                    } else {
                        maxNumberDiscount = cart.length;
                    }

                    for (let index = 0; index < maxNumberDiscount; index++) {
                        const element = cart[index];
                        if (((element.totalPrice + element?.giftValue) * (response.message.percentaje / 100)) < response.message.max_value) {
                            if (element.gift) {
                                auxDiscount = auxDiscount + ((element.totalPrice + element?.giftValue) * (response.message.percentaje / 100))
                            } else {
                                auxDiscount = auxDiscount + ((element.totalPrice) * (response.message.percentaje / 100))
                            }

                        } else {
                            auxDiscount = auxDiscount + response.message.max_value;
                        }
                    }
                    setDiscount(auxDiscount);
                } else {
                    setShowDiscountAlert(true);
                    setCuponApply(false);
                    setDiscountCode('');
                    setDiscount(0);
                }
            })
        }
    }


    return (
        <MyCartContainer>
            <div className="goBack" onClick={() => navigate(-1)}>
                <img src={arrowBack} alt="back" className="backIcon" />
                <p className="backText" ><FormattedMessage id="go_back" defaultMessage="ir atrás" /></p>
            </div>
            <div className="cartBody">
                <section className="cartInformation">
                    <h3 className="cartTitle"><FormattedMessage id="cart_title" defaultMessage="Carrito de compras" /></h3>

                    {(cart.length > 0 && cart !== null) ? (<><div className="influencerData">
                        <div className="address">
                            <p className="addressTitle"><FormattedMessage id="cart_text_1" defaultMessage="Dirección" /></p>
                            <p>{companyName}</p>
                            <p>{address}</p>
                            <p>{city && `${city}, `}{(locale === 'es-CO') ? country?.nombre : country?.name}</p>
                            <p>{(phone !== '' && phone !== null) && `(+${indicativePhone}) ${phone}`}</p>

                        </div>
                        <div className="paymentMethod">
                            <p className="paymentTitle"><FormattedMessage id="cart_text_2" defaultMessage="Método de pago" /></p>
                            <div className="method"><img src={cash} alt="card" className="cardIcon" /><span><FormattedMessage id="cart_text_3_a" defaultMessage="Efectivo" /> {(hasGifts) && (<FormattedMessage id="cart_text_3_b" defaultMessage=" + regalo" />)}</span></div>
                        </div>
                        <div className="promotionalCode">
                            <p className="codeTitle"><FormattedMessage id="cart_text_4" defaultMessage="Código de descuento" /></p>
                            <div>
                                <input type="text" className="codeInput" /* placeholder= {intl.formatMessage({ id: "cart_input" })} */ value={discountCode} onChange={(event) => {
                                    setDiscountCode(event.target.value)
                                    setCuponApply(false)
                                    setDiscount(0);
                                }} />
                                <button className="applyButton" onClick={() => {
                                    applyDiscount()
                                }}><FormattedMessage id="cart_text_button_1" defaultMessage="Aplicar" /></button>
                            </div>
                        </div>
                    </div>
                        <div className="cartItems">
                            {(showCollaborationCart) && cart.map((collaboration, index) => {

                                return (<CollaborationCart collaboration={collaboration} setEditCollaborationData={setEditCollaborationData}
                                    setShowEditCollaboration={setShowEditCollaboration} handlerDeleteCollaboration={handlerDeleteCollaboration} />)
                            })}
                        </div></>) : <div className="emptyCart"><p><FormattedMessage id="cart_text_14" defaultMessage="Aún no has añadido colaboraciones al carrito" /></p></div>}
                </section>

                {(cart.length > 0 && cart !== null) && (<section className="cartCheckout">
                    <table className="checkout">
                        <tr>
                            <th><FormattedMessage id="cart_text_8" defaultMessage="Total" /></th>
                            <th className="price">{currency.symbol}</th>
                            <th className="price">USD</th>
                        </tr>
                        <tr>
                            <td><FormattedMessage id="cart_text_9" defaultMessage="Subtotal" /></td>
                            <td className="price">$ {formatNumber(auxCartTotal)}</td>
                            <td className="price">$ {formatNumber(cartTotal)}</td>
                        </tr>
                        <tr>
                            <td><FormattedMessage id="cart_text_10" defaultMessage="Descuento" /></td>
                            <td className="price">$ {formatNumber(auxDiscount)}</td>
                            <td className="price">$ {formatNumber(discount)}</td>
                        </tr>
                        <tr className="beforeTotal">
                            <td><FormattedMessage id="cart_text_11" defaultMessage="Impuestos" /></td>
                            <td className="price">$ {formatNumber(auxTaxes)}</td>
                            <td className="price">$ {formatNumber(taxes)}</td>
                        </tr>
                        <tr >
                            <td></td>
                            <td ></td>
                            <td className="totalPrice">$ {formatNumber(cartTotal - discount + taxes)}</td>
                        </tr>


                    </table>
                    <div className="mobilePromotionalCode">
                        <p className="codeTitle"><FormattedMessage id="cart_text_4" defaultMessage="Código de descuento" /></p>
                        <div>
                            <input type="text" className="codeInput" placeholder={intl.formatMessage({ id: "cart_input" })} value={discountCode} onChange={(event) => {
                                setDiscountCode(event.target.value)
                                setCuponApply(false)
                                setDiscount(0);
                            }} />
                            <button className="applyButton" onClick={() => {
                                applyDiscount()
                            }}><FormattedMessage id="cart_text_button_1" defaultMessage="Aplicar" /></button>
                        </div>
                    </div>

                    {((cartTotal - discount + taxes) > 0) ?
                        (payment) ? (<PayPalScriptProvider options={initialOptions}>
                            <Checkout amount={cartTotal - discount + taxes} setShowCollaborationSent={setShowCollaborationSent} />
                        </PayPalScriptProvider>)
                            : (<button className="checkoutButton" onClick={() => setShowPaypalAlert(true)}> <FormattedMessage id="cart_text_button_2" defaultMessage="Pagar" /> USD $ {formatNumber(cartTotal - discount + taxes)}</button>) : (<button className="checkoutButton" onClick={payCollaboration}> <FormattedMessage id="cart_text_button_2" defaultMessage="Pagar" /> USD $ 0</button>)}

                    {/* <button className="checkoutButton" onClick={payCollaboration}> <FormattedMessage id="cart_text_button_2" defaultMessage="Pagar" /> USD $ {formatNumber(cartTotal - discount + taxes)}</button> */}

                    {/* {(payment) ? (<PayPalScriptProvider options={initialOptions}>
                        <Checkout amount={cartTotal - discount + taxes} setShowCollaborationSent={setShowCollaborationSent} />
                    </PayPalScriptProvider>) : (<button className="checkoutButton" onClick={payCollaboration}> <FormattedMessage id="cart_text_button_2" defaultMessage="Pagar" /> USD $ {formatNumber(cartTotal - discount + taxes)}</button>)} */}

                    <p className="paypalInfo"><FormattedMessage id="cart_paypal_information" defaultMessage="*Facturado en USD (otras monedas son sólo estimaciones, sujetas a comisiones por transacciones extranjeras)" /></p>
                </section>)}

            </div>

            {(showCollaborationSent) && (<ModalSendCollaboration setShowCollaborationSent={setShowCollaborationSent} influencerName={influencerName} />)}

            {(isLoading) && (<Spinner />)}

            {(showEditCollaboration) && (<ModalEditCollaboration setShowEditCollaboration={setShowEditCollaboration} collaborationData={editCollaborationData} />)}

            {(showPaypalAlert) && (<Alert
                title={<FormattedMessage id="Error_title" defaultMessage="¡Lo sentimos!" />}
                text={<FormattedMessage id="alert_connect_paypal" defaultMessage="Para continuar con esta operación deberas primero vincular tu cuenta de Paypal" />}
                confirmText={<FormattedMessage id="alert_button_paypal" defaultMessage="Conectar Paypal" />}
                onConfirm={() => {
                    sessionStorage.setItem('paypalLoginOrigin', 'cart')
                    window.location = `${paypalURL}/${userType}?authorization=${userToken}`;
                    /* const myHeader = userToken;
                    const myHeaderKey = 'Authorization';
                    document.cookie = myHeaderKey + '= Bearer ' + myHeader; */
                }}
                setShowAlert={setShowPaypalAlert}
            />)}

            {(showDiscountAlert) && (<Alert
                title={<FormattedMessage id="Error_title" defaultMessage="¡Lo sentimos!" />}
                text={<FormattedMessage id="alert_discount_paypal" defaultMessage="Este cupón ya no se encuentra disponible." />}
                setShowAlert={setShowDiscountAlert}

            />)}

        </MyCartContainer>
    )
}